import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacySliderChange as MatSliderChange } from '@angular/material/legacy-slider';
import { trackByValue } from '@y42/angular/util';
import { BorderStyle, ToolbarBorderStyle } from '../../../shared/model';

@Component({
  selector: 'y42-context-menu-border-style',
  templateUrl: './context-menu-border-style.component.html',
  styleUrls: ['context-menu-border-style.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuBorderStyleComponent {
  constructor(private readonly cd: ChangeDetectorRef) {}

  protected readonly defaultBorderStyle: ToolbarBorderStyle = {
    borderWidth: 0,
    borderStyle: 'solid',
  };

  protected readonly trackByValue = trackByValue;

  isMenuOpen = false;

  @Input()
  borderStyle?: ToolbarBorderStyle;

  @Input()
  label = 'Border style';

  @Input()
  borderStyles: BorderStyle[] = ['solid', 'dashed', 'dotted'];

  @Output()
  borderStyleChanged = new EventEmitter<ToolbarBorderStyleChangeEvent>();

  closeOverlay() {
    this.isMenuOpen = false;
    this.cd.markForCheck();
  }

  onBorderWidthChange(width: MatSliderChange) {
    if (width.value === null) {
      return;
    }

    this.borderStyleChanged.emit({
      ...(this.borderStyle || this.defaultBorderStyle),
      borderWidth: width.value,
      changed: 'borderWidth',
    });
  }

  onStrokeDashArrayChange(newBorderStyle: BorderStyle) {
    this.borderStyleChanged.emit({
      ...(this.borderStyle || this.defaultBorderStyle),
      borderStyle: newBorderStyle,
      changed: 'borderStyle',
    });
  }
}

export interface ToolbarBorderStyleChangeEvent extends ToolbarBorderStyle {
  changed: keyof ToolbarBorderStyle;
}
